import * as listeDevis from './listeDevis';
import * as sidebar from './sidebar';

// eslint-disable-next-line import/prefer-default-export
export const PAGES = {
  listeDevis: listeDevis.LISTE_DEVIS,
  sidebar: sidebar.SIDEBAR,
};
